import styled from 'styled-components';

import { xdlColorBorderSoft } from '@xing-com/tokens';

export const Header = styled.div`
  border-bottom: 1px solid ${xdlColorBorderSoft};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const JobBoxLink = styled.div`
  display: flex;
  flex-direction: row;
  line-height: 1;
`;
